import { DISPLAY_NAME, useSelectContext } from '../../input-select'

import type { ScopedProps } from '../../input-select.types'

import { OptionMenu } from '~/components/option-menu'

type SelectItemProps = React.ComponentProps<typeof OptionMenu.Item> & {
  value: string | number
  testID?: string
}

function SelectItem(props: SelectItemProps) {
  const { value, checked, __scopeSelect, ...rest } =
    props as ScopedProps<SelectItemProps>

  const { onSelectedValue, selectedValue, isFocused, setTriggerToggle } =
    useSelectContext(DISPLAY_NAME, __scopeSelect)

  const isItemChecked = checked || value === selectedValue

  function handleSelectItem() {
    onSelectedValue(value.toString())
    setTriggerToggle('close')
  }

  return (
    <>
      <OptionMenu.Item
        {...rest}
        onPress={handleSelectItem}
        checked={isItemChecked}
      />
    </>
  )
}

export { SelectItem }
